import { Drawer } from 'antd';
import type { UnresolvedVendorErrorCodeResponseDto } from '@evimo/client/models';
import { useTranslation } from 'react-i18next';
import { UnresolvedObservationSection } from '~/app/components/errorManagement/UnresolvedVendorErrorCodeViewDrawer/UnresolvedObservationSection';
import { VendorErrorCodeCatalogSections } from '~/app/components/errorManagement/VendorErrorCodeCatalogSections/VendorErrorCodeCatalogSections';
import { ViewDrawerTitle } from '~/app/components/errorManagement/ViewDrawerTitle/ViewDrawerTitle';

export interface UnresolvedVendorErrorCodeViewDrawerProps {
  open: boolean;
  record: UnresolvedVendorErrorCodeResponseDto | null;
  onClose: () => void;
}

export function UnresolvedVendorErrorCodeViewDrawer({
  open,
  record,
  onClose,
}: UnresolvedVendorErrorCodeViewDrawerProps) {
  const { t } = useTranslation('errorManagement');

  return (
    <Drawer
      open={open}
      width={560}
      title={
        <ViewDrawerTitle
          title={t('unresolved.viewDrawer.title')}
          errorCode={record?.errorCode}
        />
      }
      onClose={onClose}
      destroyOnClose
    >
      {record ? (
        <>
          <UnresolvedObservationSection record={record} />
          <VendorErrorCodeCatalogSections
            record={record}
            showSourceDescription
          />
        </>
      ) : null}
    </Drawer>
  );
}
